import React from "react";

const OptimusGap = () => {
  return <></>;
};

export default OptimusGap;
